import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Units } from '@iotv/iotv-v3-types';
import { Checkbox, InputAdornment, Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { camelCase_to_Sentence, toTitleCase } from '../../../../../helpers/format';
import { AutosizedTextField } from '../../../../common/AutosizedTextField';
import { Arbitrator, AttributeModiferKeys } from './Arbitrator';
const INITIAL = '';
export const NumberAttribute = (props) => {
    const { name, attribute, rangeLimits, disable, isRoot } = props;
    const [checked, setChecked] = useState(false);
    const [value, setValue] = useState(INITIAL);
    const disabled = isRoot ? !checked : disable;
    useEffect(() => {
        if (disabled)
            setChecked(false);
        if (value !== INITIAL && disabled)
            setValue(INITIAL);
    }, [disabled, value]);
    const more = [];
    const payload = {};
    let valid = !disabled;
    const { attributeType, range, ...others } = rangeLimits;
    for (const [key, other] of Object.entries(others)) {
        if (!AttributeModiferKeys.includes(key)) {
            const { elements, payload: p, valid: v, } = Arbitrator({
                name: key,
                attribute,
                rangeLimits: other,
                disable: isRoot ? !checked : disable,
                isRoot: false,
            });
            more.push(elements);
            payload[name] ??= {};
            if (p[key] !== undefined)
                payload[name][key] = p[key];
            valid = valid && v;
        }
    }
    const readableName = toTitleCase(camelCase_to_Sentence(name));
    const { min, max } = range;
    const unit = attribute.unit;
    const unitName = unit !== undefined && unit !== Units.Unknown ? Units[unit] : undefined;
    const placeholder = min + ' - ' + max;
    const float = Number.parseFloat(value);
    const int = Number.parseInt(value);
    const number = float === int ? int : NaN;
    valid = valid && !isNaN(number) && min <= number && number <= max;
    if (!disabled && valid)
        payload[name] = number;
    const present = isRoot && _jsx(Checkbox, { checked: checked, onChange: (e) => setChecked(e.target.checked), disabled: disable });
    const control = (_jsx(AutosizedTextField, { value: value, onChange: (e) => setValue(e.target.value), placeholder: placeholder, autoComplete: "number", disabled: disabled, error: !valid, slotProps: {
            input: {
                endAdornment: unitName ? (_jsx(InputAdornment, { position: "end", sx: { opacity: disabled ? 0.6 : undefined }, children: unitName })) : undefined,
            },
        } }));
    const elements = more.length ? (_jsxs(Stack, { direction: "row", alignItems: "center", gap: 1, children: [present, _jsx(Typography, { children: readableName }), control, _jsxs(Stack, { gap: 1, children: [...more] })] })) : (_jsxs(Stack, { direction: "row", alignItems: "center", gap: 1, children: [present, !isRoot && _jsx(Typography, { color: disabled ? 'textDisabled' : undefined, children: readableName }), control] }));
    return { elements, payload, valid };
};
